module.exports = __webpack_public_path__ + "img/殷文聪.343822a7.jpg";